module.exports = __webpack_public_path__ + "static/media/logo-vaud.72937ee3.png";